export default __webpack_public_path__ + "static/media/eldhotbabu.df427c0c.jpg";